import type { To } from "react-router-dom";

import { Link } from "@/newComponents";

type BreadcrumbLinkProps = {
  readonly to: To;
  readonly text: string;
  readonly showBackArrow?: boolean;
};

export function BreadcrumbLink({
  to,
  text,
  showBackArrow = false,
}: BreadcrumbLinkProps): React.ReactElement {
  const linkText = showBackArrow ? `\u2190 ${text}` : text;

  return (
    <Link
      className="inline-flex items-center hover:text-content focus-visible:ring-2 focus-visible:outline-hidden"
      to={to}
    >
      <span className="block type-body-sm font-medium text-inherit">{linkText}</span>
    </Link>
  );
}
